import React from 'react';
import Footer from './Footer';

const TermsOfService: React.FC = () => {
  const handleGoHome = () => {
    window.location.hash = '#/';
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
      <header className="bg-white dark:bg-gray-800 shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* App Title - Clickable */}
            <div className="flex items-center">
              <h1 
                className="text-2xl font-bold text-primary dark:text-primary cursor-pointer hover:text-primary-dark transition-colors"
                onClick={handleGoHome}
                title="Back to Get Deleto"
              >
                Get Deleto
              </h1>
            </div>
            
            {/* Theme Toggle */}
            <div className="flex items-center">
              <button
                onClick={() => {
                  const currentTheme = localStorage.getItem('theme') || 'light';
                  const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
                  localStorage.setItem('theme', newTheme);
                  document.documentElement.classList.toggle('dark', newTheme === 'dark');
                }}
                className="p-2 rounded-md transition-all duration-300 flex items-center justify-center overflow-hidden relative focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
                style={{
                  background: (localStorage.getItem('theme') || 'light') === 'dark' 
                    ? 'linear-gradient(135deg, #4a90e2 0%, #2d3748 100%)' 
                    : 'linear-gradient(135deg, #f6ad55 0%, #f8f9fa 100%)',
                  width: '40px',
                  height: '40px'
                }}
                title={(localStorage.getItem('theme') || 'light') === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
                aria-label={(localStorage.getItem('theme') || 'light') === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
              >
                <span className="absolute inset-0 flex items-center justify-center">
                  {(localStorage.getItem('theme') || 'light') === 'dark' ? (
                    <svg className="w-5 h-5 text-yellow-300 transform transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 2a6 6 0 110 12 6 6 0 010-12z" fillOpacity="0" />
                      <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                    </svg>
                  ) : (
                    <svg className="w-5 h-5 text-indigo-900 transform transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                    </svg>
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </header>
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-8">
          <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-white">Terms of Service</h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">1. Acceptance of Terms</h2>
            <p>By accessing or using Get Deleto, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">2. Use License</h2>
            <p>Permission is granted to temporarily use Get Deleto for personal, non-commercial writing purposes. This is the grant of a license, not a transfer of title.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">3. Disclaimer</h2>
            <p>The materials on Get Deleto are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">4. Limitations</h2>
            <p>In no event shall Get Deleto or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use Get Deleto, even if we or an authorized representative has been notified orally or in writing of the possibility of such damage.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">5. Your Content</h2>
            <p>Get Deleto does not claim ownership of the content you create using our service. Your content is stored locally on your device and is not accessed by us unless you explicitly choose to use any cloud features we may offer in the future.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">6. Revisions and Errata</h2>
            <p>The materials appearing on Get Deleto could include technical, typographical, or photographic errors. We do not warrant that any of the materials on the website are accurate, complete, or current. We may make changes to the materials contained on the website at any time without notice.</p>
            
            
            <h2 className="text-xl font-semibold mt-6 mb-4">7. Modifications</h2>
            <p>We may revise these Terms of Service at any time without notice. By using Get Deleto, you agree to be bound by the current version of these Terms of Service.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">8. Governing Law</h2>
            <p>These terms and conditions are governed by and construed in accordance with the laws of The United States and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
            
            <h2 className="text-xl font-semibold mt-6 mb-4">9. Contact Us</h2>
            <p>If you have any questions about these Terms of Service, please contact us at getdeleto@gmail.com.</p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsOfService; 